module.exports = __webpack_public_path__ + "assets/53d3966edf1ef9872a9d3b2bda26759e.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/PreWolfJump.mp3
 ** module id = 382
 ** module chunks = 0
 **/